module.exports = __webpack_public_path__ + "img/newLoginLogo.c1b78e43.png";